var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEinstellung(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.21 171.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{opacity:0.7;}.cls-3{fill:#d41c0d;}.cls-4{fill:#d40613;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landingpage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modul_-_Grafik_Vorgang",
    "data-name": "Modul - Grafik / Vorgang"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.68,119.43a47.14,47.14,0,1,0,32.65-58.12,47.14,47.14,0,0,0-32.65,58.12"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.62,119.47a47.14,47.14,0,1,0,32.65-58.12,47.14,47.14,0,0,0-32.65,58.12"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.82,59.88A47.14,47.14,0,1,0,34.48,1.76,47.14,47.14,0,0,0,1.82,59.88"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.76,59.92A47.14,47.14,0,1,0,34.42,1.8,47.13,47.13,0,0,0,1.76,59.92"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.62,171.38a77.5,77.5,0,1,1,77.5-77.5A77.5,77.5,0,0,1,118.62,171.38Zm48.54-94a5,5,0,0,0,0-7.07l-7.07-7.07a5,5,0,0,0-7.08,0l-46.89,46.89L84.23,88.28a5,5,0,0,0-7.07,0l-7.08,7.07a5,5,0,0,0,0,7.07l32.5,32.5a5,5,0,0,0,7.08,0Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEinstellung);
export default __webpack_public_path__ + "static/media/Einstellung.f8ca6b22f213943834bec9e6af9bee57.svg";
export { ForwardRef as ReactComponent };